"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getMember: ()=>getMember,
    createMemberPassword: ()=>createMemberPassword,
    loginByPhoneNumber: ()=>loginByPhoneNumber,
    validatePin: ()=>validatePin,
    createMembers: ()=>createMembers,
    updateMember: ()=>updateMember,
    checkAuth: ()=>checkAuth,
    logoutAuth: ()=>logoutAuth,
    authPin: ()=>authPin,
    requestPin: ()=>requestPin,
    syncFbToken: ()=>syncFbToken,
    deleteAccount: ()=>deleteAccount,
    useCheckAuth: ()=>useCheckAuth,
    useLogOut: ()=>useLogOut,
    useAuthPin: ()=>useAuthPin,
    useRequestPin: ()=>useRequestPin,
    useGetMember: ()=>useGetMember,
    useLoginByPhoneNumber: ()=>useLoginByPhoneNumber,
    useCreateMemberPassword: ()=>useCreateMemberPassword,
    useGetMemberPin: ()=>useGetMemberPin,
    useCreateMembers: ()=>useCreateMembers,
    useUpdateMember: ()=>useUpdateMember,
    useSyncFbToken: ()=>useSyncFbToken,
    useDeleteAccount: ()=>useDeleteAccount,
    patchAcknowledgeNotification: ()=>patchAcknowledgeNotification,
    useAcknowledgeNotification: ()=>useAcknowledgeNotification
});
const _reactQuery = require("react-query");
const _ = require("../..");
_exportStar(require("./profile"), exports);
function _exportStar(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) Object.defineProperty(to, k, {
            enumerable: true,
            get: function() {
                return from[k];
            }
        });
    });
    return from;
}
const getMember = async (payload, opts)=>{
    const response = await _.api.get(`/wallet/v1/members/${payload.walletId}`, opts);
    return response.member;
};
const createMemberPassword = async (payload, opts)=>{
    const response = await _.api.put(`/wallet/v1/members/${payload.walletId}`, payload, opts);
    return response.member;
};
const loginByPhoneNumber = async (payload, opts)=>{
    return await _.api.post('/join/v1/member_access_codes', payload, opts);
};
const validatePin = async (payload, opts)=>{
    const { accessCode , memberAccessCodeId , firebase_token  } = payload;
    return await _.api.get(`/join/v1/member_access_codes/${memberAccessCodeId}?access_code=${accessCode}&firebase_token=${firebase_token}`, opts);
};
const createMembers = async (payload, opts)=>{
    const response = await _.api.post('/native_app/v1/members/', payload, opts);
    return response;
};
const updateMember = async ({ payload , firebaseToken , walletId  }, opts)=>{
    await _.api.patch(`native_app/v2/members`, {
        member: {
            ...payload.member,
            interest_list: payload.interest_list
        },
        signature: payload.signature,
        firebaseToken
    }, opts);
    return await getMember({
        walletId
    }, opts);
};
const checkAuth = async (payload, opts)=>{
    let queryString = `wallet/auth/v1/remember_me/${payload.stashboardOrMemberKey}?${payload.reference}=1`;
    if (payload.skip_tendlc) {
        queryString += `&skip_tendlc=${payload.skip_tendlc}`;
    }
    if (payload.merger_wallet_id) {
        queryString += `&merger_wallet_id=${payload.merger_wallet_id}`;
    }
    return await _.rememberMeApi.get(queryString, opts);
};
const logoutAuth = async ()=>{
    return await _.rememberMeApi.get('wallet/auth/v1/remember_me/logout/');
};
const authPin = async (payload, opts)=>{
    return await _.rememberMeApi.put(`wallet/auth/v1/remember_me/${payload.stashboardOrMemberKey}?${payload.reference}=1`, {
        pin: payload.pin,
        birthday: payload.birthday,
        merger_wallet_id: payload.merger_wallet_id
    }, opts);
};
const requestPin = async (payload, opts)=>{
    return await _.api.put(`wallet/auth/v1/send_pin/${payload.stashboardOrMemberKey}?${payload.reference}=1`, payload, opts);
};
const syncFbToken = async (payload, opts)=>{
    const response = await _.api.put(`native_app/v1/push_notification_settings/sync`, payload, opts);
    return response;
};
const deleteAccount = async (payload, opts)=>{
    const response = await _.api.post(`native_app/v2/members/destroy`, payload, opts);
    return response;
};
const useCheckAuth = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMobileSubscriberId , setPhoneNumber , setWalletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>checkAuth(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            setStore({
                phoneNumber: data.phone_number
            });
            setStore({
                mobileSubscriberId: data.mobile_subscriber
            });
            setPhoneNumber(data.phone_number);
            setMobileSubscriberId(data.mobile_subscriber);
            setWalletId(data.merchant_member_key);
        }
    });
};
const useLogOut = (queryOptions = {})=>{
    const { cleanState  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)(()=>logoutAuth(), {
        ...queryOptions,
        onSuccess: ()=>{
            cleanState();
        },
        onError: (data)=>{
            console.log(data, 'error');
        }
    });
};
const useAuthPin = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMobileSubscriberId , setPhoneNumber , setWalletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>authPin(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            setStore({
                phoneNumber: data.phone_number
            });
            setStore({
                mobileSubscriberId: data.mobile_subscriber
            });
            setPhoneNumber(data.phone_number);
            setMobileSubscriberId(data.mobile_subscriber);
            setWalletId(data.merchant_member_key);
        }
    });
};
const useRequestPin = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>requestPin(payload), {
        ...queryOptions
    });
};
const useGetMember = (queryOptions = {})=>{
    const { walletId , setMember , firebaseToken  } = (0, _.useSpringBigStore)();
    const shouldFetch = walletId;
    return (0, _reactQuery.useQuery)('members', ({ signal  })=>shouldFetch ? getMember({
            walletId,
            firebaseToken
        }, {
            signal
        }) : Promise.resolve(null), {
        ...queryOptions,
        onSuccess: (data)=>{
            if (data) {
                setMember(data);
            }
        }
    });
};
const useLoginByPhoneNumber = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMemberAccessCodeId , setPhoneNumber , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>loginByPhoneNumber({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (data, variables)=>{
            setStore({
                phoneNumber: variables.phone_number
            });
            setPhoneNumber(variables.phone_number);
            setMemberAccessCodeId(data.member_access_code_id);
        }
    });
};
const useCreateMemberPassword = (queryOptions = {})=>{
    const { walletId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>createMemberPassword({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (response)=>{
            console.log(response);
        }
    });
};
const useGetMemberPin = (queryOptions = {})=>{
    const { setStore  } = (0, _.useApi)();
    const { setMobileSubscriberId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>validatePin({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (data)=>{
            setStore({
                mobileSubscriberId: data.mobile_subscriber
            });
            setMobileSubscriberId(data.mobile_subscriber);
        }
    });
};
const useCreateMembers = (queryOptions = {})=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { setMember , setWalletId , setMerchantId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>createMembers({
            ...payload,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (data)=>{
            if (data && data.member?.wallet_id) {
                setMember(data.member);
                setWalletId(data.member.wallet_id);
            }
            if (data && data.member?.merchant_id) {
                setMerchantId(data.member.merchant_id);
            }
            queryClient.invalidateQueries('merchants');
        }
    });
};
const useUpdateMember = (queryOptions = {})=>{
    const { phoneNumber , member , firebaseToken , setMember , walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>updateMember({
            payload: {
                signature: payload.signature,
                interest_list: payload.interest_list,
                member: {
                    ...payload.member,
                    phone_number: phoneNumber,
                    merchant_id: member?.merchant_id
                }
            },
            walletId: walletId,
            firebaseToken
        }), {
        ...queryOptions,
        onSuccess: (data)=>{
            if (data) {
                setMember(data);
            }
        }
    });
};
const useSyncFbToken = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>syncFbToken(payload), queryOptions);
};
const useDeleteAccount = (queryOptions = {})=>{
    const { cleanState  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>deleteAccount(payload), {
        ...queryOptions,
        onSuccess: ()=>{
            cleanState();
        },
        onError: (data)=>{
            console.log(data, 'error');
        }
    });
};
const patchAcknowledgeNotification = async ({ notification_id , wallet_id  })=>{
    return _.api.patch(`/wallet/v1/members/${wallet_id}/notifications/${notification_id}/acknowledge`);
};
const useAcknowledgeNotification = (queryOptions = {})=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)(({ notification_id  })=>patchAcknowledgeNotification({
            notification_id: notification_id,
            wallet_id: walletId
        }), queryOptions);
};
